// extracted by mini-css-extract-plugin
module.exports = {"addProjectsWrapper":"AddProjectsModal_addProjectsWrapper__31DQV","actions":"AddProjectsModal_actions__12YAi","cancel_btn":"AddProjectsModal_cancel_btn__C5BwM"};